// 按服务端模块制定前缀
const PREFIX = "";
// 接口迁移，所有的接口模块由该文件统一对外导出
// 命名不包含前缀‘{PREFIX}’和最后一个‘/’后面的字符
// 使用全大写，使用‘_’替换‘/’，如'rco/clouddesktop/deskNetwork/list'对外的模块名‘CLOUDDESKTOP_DESKNETWORK’

const CASE_MNG = "testcase";
const INDUSTRY_MNG = "industry";
const POC_MNG = "projectInfo";
const DELIVERY_PROJECT_MNG = "delivery/project";
const DELIVERY_NETWORK_MNG = "delivery/network";

const DELIVERY_PROJECT_POSITION_MNG = "delivery/project/position";
const DELIVERY_PROJECT_REQUIREMENT_MNG = "delivery/project/requirement";
const SCENE_MNG = "scene";
const SCENE_DIR_MNG = "sceneDir";

const EVN_CONFIRM_MNG = "project/env";

const SCENE_COLLECT_MNG = "scene/collect";

const POC_MNG_SCENE_RESEARCH = "sceneResearch";

const SOFTWARE_MNG = "software";

const SOFTWARE_BLACK_MNG = "software/black";

const PLAN_MNG = "plan";
const DELIVERY_PLAN_MNG = "deliveryPlan";

const FEATURE_MNG = "feature";
const CASESOFTWARE_MNG = "testcase/software";
const CASEPERIPHERAL_MNG = "testcase/peripheral";
const CASEBUSI_MNG = "testcase/busi";

const AREA_INDUSTRY_USER_MNG = "areaIndustryUser";

const PERMISSION = "permission";

const OSTYPE_MNG = "osType";
const OS_TYPE_CONFIG_MNG = "osTypeConfig";
const COMMON_MNG = "/global/enum";
const SERVER_MNG = "server";
const TERMINAL_MNG = "terminal";
const PERIPHERAL = "peripheral";

const PRODUCT_MNG = "product";
const COLLECT_REPORT = "collect/report";
const CASE_REPO = "testcase/caseRepo";
const TOOL = "tool";
const DELIVERY_GUIDE = "guide";
const LIMIT = "limit";
const FEEDBACK = "feedback";
const FEATURE_LIMIT = "featureLimit";
const STEP_DATA = "stepData";
const SYSTEM = "system";
const SYSTEM_INFO = "systemInfo";
const BATCH_MAINTENANCE = "batch/maintenance";
const PROJECT_MONITOR = "project/monitor";
const NPS = "nps";
const NPS_STRATEGY = "nps/strategy";
const APPROVAL = "approval";
const CAL_GPU_CARD_MNG = "gpuCard";
const CAL_SOFTWARE_MNG = "cal/software";
const CAL_DESKTOP_ELEMENT_MNG = "/desktop/element";
const CAL_SEGMENT_SCENE_MNG = "/segment/scene";
const CAL_SERVER_ORDER_MNG = "server/order";
const POSITION_MNG = "position";
const FEATURE_VALUE_MNG = "featureValue";
const COLLECT_COMPAT = "collect/compat";

const SERVICE_PRICE_INVITE_CODE = "servicePrice/inviteCode";
const SERVICE_PRICE_OP_AUDIT = "servicePrice/opAudit";

export {
  COLLECT_COMPAT,
  POSITION_MNG,
  NPS_STRATEGY,
  SYSTEM_INFO,
  FEATURE_VALUE_MNG,
  DELIVERY_PLAN_MNG,
  PREFIX,
  CASE_MNG,
  OS_TYPE_CONFIG_MNG,
  CASE_REPO,
  POC_MNG,
  DELIVERY_PROJECT_MNG,
  DELIVERY_NETWORK_MNG,
  POC_MNG_SCENE_RESEARCH,
  SCENE_MNG,
  SCENE_COLLECT_MNG,
  BATCH_MAINTENANCE,
  INDUSTRY_MNG,
  SOFTWARE_MNG,
  FEATURE_MNG,
  CASESOFTWARE_MNG,
  CASEPERIPHERAL_MNG,
  CASEBUSI_MNG,
  OSTYPE_MNG,
  SCENE_DIR_MNG,
  COMMON_MNG,
  FEEDBACK,
  SERVER_MNG,
  TERMINAL_MNG,
  PERIPHERAL,
  PLAN_MNG,
  EVN_CONFIRM_MNG,
  PRODUCT_MNG,
  COLLECT_REPORT,
  TOOL,
  DELIVERY_GUIDE,
  FEATURE_LIMIT,
  LIMIT,
  STEP_DATA,
  SYSTEM,
  PROJECT_MONITOR,
  NPS,
  SOFTWARE_BLACK_MNG,
  APPROVAL,
  CAL_GPU_CARD_MNG,
  CAL_SOFTWARE_MNG,
  CAL_DESKTOP_ELEMENT_MNG,
  CAL_SEGMENT_SCENE_MNG,
  CAL_SERVER_ORDER_MNG,
  DELIVERY_PROJECT_POSITION_MNG,
  DELIVERY_PROJECT_REQUIREMENT_MNG,
  AREA_INDUSTRY_USER_MNG,
  PERMISSION,
  SERVICE_PRICE_INVITE_CODE,
  SERVICE_PRICE_OP_AUDIT,
};
